import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import ReactGA from "react-ga";
import Navbar from "./components/Navbar";
import OverlayText from "./components/OverlayText";
import AboutUs from "./pages/AboutUs";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import Team from "./pages/Team";
import Footer from "./components/Footer";
import Threads from "./blocks/Backgrounds/Threads/Threads";
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';

// Initialize GA only once
const TRACKING_ID = "G-JYSGZCXZF0";
ReactGA.initialize(TRACKING_ID);

function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);
}

function HomePage() {
  return (
    <div style={{ scrollSnapType: 'y mandatory', overflowY: 'scroll', height: '100vh' }}>
      <div style={{ width: '100vw', height: '100vh', position: 'relative', scrollSnapAlign: 'start' }}>
        <Threads amplitude={1} distance={0} enableMouseInteraction={true} />
        <OverlayText />
      </div>
      <div className="surface-0 text-center aboutus-solutions" style={{ scrollSnapAlign: 'start', padding: '4rem 1rem', minHeight: '100vh' }}>
        <br />
        <br />
        <div className="mb-3 font-bold text-3xl">
          <span className="text-900">Low Cost, </span>
          <span className="text-blue-600">High Privacy</span>
        </div>
        <div className="text-700 mb-6 text-lg">We offer budget-friendly custom websites built with end-to-end privacy—no open source, no compromises.</div>
        <div className="grid">
          <div className="col-12 md:col-4 mb-4 px-5">
            <span className="p-3 shadow-2 mb-3 inline-block" style={{ borderRadius: '10px' }}>
              <i className="pi pi-wallet text-4xl text-blue-500"></i>
            </span>
            <div className="text-900 text-xl mb-3 font-medium">Affordable</div>
            <span className="text-700 line-height-3">Get powerful digital solutions without burning a hole in your pocket.</span>
          </div>
          <div className="col-12 md:col-4 mb-4 px-5">
            <span className="p-3 shadow-2 mb-3 inline-block" style={{ borderRadius: '10px' }}>
              <i className="pi pi-lock text-4xl text-blue-500"></i>
            </span>
            <div className="text-900 text-xl mb-3 font-medium">Private & Secure</div>
            <span className="text-700 line-height-3">Your data is yours alone—no open-source reuse, full encryption.</span>
          </div>
          <div className="col-12 md:col-4 mb-4 px-5">
            <span className="p-3 shadow-2 mb-3 inline-block" style={{ borderRadius: '10px' }}>
              <i className="pi pi-thumbs-up text-4xl text-blue-500"></i>
            </span>
            <div className="text-900 text-xl mb-3 font-medium">Easy to Use</div>
            <span className="text-700 line-height-3">We build platforms even your grandma could love. Simple, clear, powerful.</span>
          </div>
        </div>
      </div>
    </div>
  );
}

function AppContent() {
  const location = useLocation();
  usePageTracking();

  useEffect(() => {
    document.body.style.overflowX = "hidden";
  }, [location]);

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/Team" element={<Team />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Router>
        <AppContent />
      </Router>
    </div>
  );
}

export default App;
